import { Link } from "react-router-dom";

interface BrandMarkProps {
  compact?: boolean;
}

export default function BrandMark({ compact = false }: BrandMarkProps) {
  return (
    <Link
      to="/"
      className="group flex items-center gap-3 cursor-pointer"
      aria-label="深夜黑料 首页"
    >
      <span className="relative flex h-11 w-11 items-center justify-center rounded-md bg-primary-600 text-foreground-950 ring-1 ring-primary-400/60 transition-transform duration-300 group-hover:-rotate-3">
        <span className="font-heading text-xl font-black leading-none">夜</span>
        <span className="absolute -bottom-1 -right-1 h-3 w-3 rounded-full bg-accent-500" />
      </span>
      {!compact && (
        <span className="flex flex-col leading-none">
          <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
            深夜黑料
          </span>
          <span className="mt-1 text-[11px] tracking-[0.28em] text-foreground-500">
            ARCHIVE
          </span>
        </span>
      )}
    </Link>
  );
}